import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CasesTreatmentsService } from '../../cases/_services/cases-treatments.service';
import { CaseTreatment } from '../../cases/_types/case-treatment';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-cases-treatments-list',
    templateUrl: './cases-treatments-list.component.html',
    styleUrls: ['./cases-treatments-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesTreatmentsListComponent {

  public casesTreatments: CaseTreatment[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public casesTreatmentsService: CasesTreatmentsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Tratamientos de expedientes");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowWrite = this.loginService.hasPermission("CASES_TREATMENTS.WRITE")
    this.allowDelete = this.loginService.hasPermission("CASES_TREATMENTS.DELETE")
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();
    if(this.filters.name == "") this.filters.name = null;

    let response = await firstValueFrom(this.casesTreatmentsService.all(params));
    this.casesTreatments = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseTreatment: any) {

    this.router.navigate(['casesTreatments/' + (caseTreatment && Object.keys(caseTreatment).length > 0 ? caseTreatment.id : 0)]);
  }

  delete(caseTreatment: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el ttratamiento?",
        header: "Eliminar tratamiento",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesTreatmentsService.delete(caseTreatment.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tratamiento eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
